import React from "react";
import styled from 'styled-components';
import Step from "./step";
import { Droppable } from "react-beautiful-dnd";

const Container = styled.div`
display:inline-block;
margin: 8px;
border: 1px solid lightgrey;
border-radius: 5px;
`;
const Title = styled.h3`padding: 8px;`;
const StepList = styled.div`
padding: 8px;
/* background-color: ${props => (props.isDraggingOver ? 'skyblue' : '#fff')}; */
/* background-color: #fff; */
`;

export default class Column extends React.Component {

	render() {
		return (
<Container>
			<Title>{this.props.column.title}</Title>
			<Droppable droppableId={this.props.column.id}>
			{(provided, snapshot) => (
				<StepList
					ref={provided.innerRef}
					{...provided.droppableProps }
					isDraggingOver={snapshot.isDraggingOver}
				>
					{this.props.steps.map((step, index) => {
						const num = step.id.replace(/^\D+/g, '');

						let matchclass = num == (index + 1) ? 'match' : 'wrong';
						// console.log('index', index);
						// console.log('num', num );
						// console.log('matchclass', matchclass);

						return <Step matchclass={matchclass} key={step.id} columnId={this.props.column.id} step={step} index={index} />;
					})}
					{provided.placeholder}
				</StepList>
			)}
			</Droppable>
		</Container>
		);
	}
}